// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__uN63G","large":"styles_large__2afAL"};